import React from 'react';

const AppReload = () => {
	return <button type="button" onClick={() => window.location.reload()}>Probeer opnieuw</button>;
};

export default AppReload;
